import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import OfferInclusionItem from 'components/Common/Inclusions/OfferInclusionItem'
import LuxPlusLabel from 'LuxKit/Label/LuxPlusLabel'

import { buildAllStandardInclusions } from 'lib/cruises/cruiseInclusionsUtils'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

interface Props {
  evergreenInclusions?: Array<App.EvergreenInclusion>
  tileInclusions?: Array<App.OfferInclusion>
  standardInclusions: Array<App.PackageInclusion>
  luxPlusInclusions: Array<App.PackageInclusion>
}

function CruiseInclusionListHomeTile({ standardInclusions, evergreenInclusions, tileInclusions, luxPlusInclusions }: Props) {
  const intl = useIntl()
  const allStandardInclusions = useMemo(() => {
    return buildAllStandardInclusions(evergreenInclusions, standardInclusions, tileInclusions, false)
  }, [evergreenInclusions, standardInclusions, tileInclusions])

  const hasStandardInclusions = !!allStandardInclusions.length
  const hasInclusions = hasStandardInclusions || !!luxPlusInclusions?.length

  return <>
    {hasInclusions && <Group direction="vertical" gap={16} horizontalAlign="start">
      {!!luxPlusInclusions.length && <LuxPlusLabel type="bonus-inclusions" />}

      {hasStandardInclusions && (
        <VerticalSpacer gap={4}>
          {allStandardInclusions.map((inclusion) => <OfferInclusionItem
            key={inclusion.id}
            inclusion={inclusion}
            colour={inclusion.isHighlighted ? 'highlight-primary-dark' : undefined}
            showMinStayDescription
          />)}
          <BodyText variant="small" colour="normal-contrast">
            {intl.formatMessage({
              id: 'gWMOgND2ZhSab_HT-_aV',
              defaultMessage: 'Available on select packages',
              description: 'Note indicating inclusions are available on select cruise packages',
            })}
          </BodyText>
        </VerticalSpacer>
      )}
    </Group>}
  </>
}

export default CruiseInclusionListHomeTile
